module.exports = __webpack_public_path__ + "static/motherless-brooklyn-e3d15bf8525e081d7597354c0b0b6eeb.jpg";